module.exports = __webpack_public_path__ + "assets/img/me_img22.208e584a.png";